<div class="col-12 billet-root-component" [ngClass]="{'confirmationBillit': showConfirmationBillet }"
  (window:beforeunload)="ngOnDestroy()">
  <ng-container *ngTemplateOutlet="templateHeader"></ng-container>
  <ng-container *ngIf="loading || loadingStrategies; else elseTemplate">
    <app-spinner-loading></app-spinner-loading>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="gridster-ignore-drag">
      <ng-container *ngIf="!showConfirmationBillet; else templateConfirmation">
        <ng-container *ngTemplateOutlet="templateBillet"></ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>

<ng-template #templateHeader>
  <div class="row header align-items-start">
    <div class="col-2 p-0 title" *ngIf="!showConfirmationBillet">BOLETA</div>
    <div class="col-4 p-0 select-billet gridster-ignore-drag" *ngIf="!showConfirmationBillet">
      <div class="mat-title" [matMenuTriggerFor]="wks" matTooltipPosition="above" matTooltip="Selecionar Boleta">
        <mat-form-field *ngIf="listBillet && listBillet?.length > 0">
          <input readonly matInput [value]="' - ' + billetSelected.name">
          <mat-icon matSuffix class="icon-arrow" svgIcon="arrow-down"></mat-icon>
        </mat-form-field>
      </div>
      <mat-menu class="custom-mat-menu worksheet mat-btn-wkst" #wks="matMenu" [overlapTrigger]="false">
        <div *ngIf="listBillet?.length > 0">
          <mat-list *ngFor="let item of listBillet">
            <mat-list-item class="list-item-menu" (click)="changeBillet(item)">
              <span>{{ item?.name }}</span>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-menu>
    </div>
    <div class="col-3 p-0 quotes" *ngIf="!showConfirmationBillit && hiddenHeaderFull">
      <div class="box">{{ model?.quote }}</div>
    </div>
    <div class="col-3 p-0 actions" [ngClass]="{'col-6': !hiddenHeaderFull }" *ngIf="!showConfirmationBillet">
      <mat-icon matSuffix class="gridster-ignore-drag" svgIcon="centralizer-on" [matTooltip]="toolTipCenterStaircaseOFF"
        (click)="forceConfigCenterElement = !forceConfigCenterElement"
        *ngIf="forceConfigCenterElement && billetSelected.id === 2"></mat-icon>
      <mat-icon matSuffix class="gridster-ignore-drag fill-none" svgIcon="centralizer-off"
        [matTooltip]="toolTipCenterStaircaseON" (click)="forceConfigCenterElement = !forceConfigCenterElement"
        *ngIf="!forceConfigCenterElement && billetSelected.id === 2"></mat-icon>
      <mat-icon matSuffix class="gridster-ignore-drag" svgIcon="engine" [matTooltip]="toolTipEngine"
        [matMenuTriggerFor]="wksEngine"></mat-icon>
      <mat-menu class="custom-mat-menu worksheet settings-component mat-btn-wkst" #wksEngine="matMenu"
        [overlapTrigger]="false">
        <div class="col-12 box-title">
          <div class="row">
            <div class="col-10 p-0 title" (click)="stopPropagation()">Configurações Boleta</div>
            <div class="col-2">
              <mat-icon matSuffix svgIcon="close" [matTooltip]="'Fechar Configurações'"></mat-icon>
            </div>
          </div>
        </div>
        <div class="col-12" (click)="stopPropagation()">
          <div class="row align-items-center">
            <mat-slide-toggle class="toggle-theme small" [checked]="hiddenHeaderFull" (change)="showHiddenHeader()">
            </mat-slide-toggle>
            <span class="option-font">Ocultar cabeçalho</span>
          </div>
          <div class="row align-items-center">
            <mat-slide-toggle class="toggle-theme small" [checked]="hiddenConfirmationBillet"
              (change)="showHiddenConfirmationBilliet()"></mat-slide-toggle>
            <span class="option-font">Ocultar PAD de confirmação</span>
          </div>
        </div>
      </mat-menu>
      <mat-icon matSuffix class="gridster-ignore-drag" svgIcon="close" [matTooltip]="tooltipRemoveFromWks"
        (click)="close()"></mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #templateBillet>
  <div class="row">
    <div class="col-12 p-0 m-hammer" *ngIf="model?.auctionHammer">
      <app-auction-hammer [timeToOpen]="timeToOpen" [priceTheory]="priceTheory" [varTheory]="varTheory">
      </app-auction-hammer>
    </div>
    <div class="col-12 p-0" *ngIf="!hiddenHeaderFull">
      <app-asset-input-header [symbolAutoComplete]="model?.quote" (onsymbolChanged)="selectAsset($event)"
        [lastTrade]="lastTrade" [coinVariation]="coinVariation" [showVariation]="showVariation"
        [hiddenInvalid]="hiddenInvalid" [variation]="variation"
        [dateLastNegotiation]="messageQuote?.dateLastNegotiation" [hourLastTrade]="messageQuote?.hourLastTrade"
        [timeUpdate]="messageQuote?.timeUpdate" [company]="company" [image]="model.imgName"></app-asset-input-header>
    </div>
  </div>
  <div class="row m-hammer" *ngIf="billetSelected.showBoxPosition">
    <app-billet-position class="col-12" [dense]="true" [position]="listPosition"></app-billet-position>
  </div>
  <div class="row" [ngSwitch]="billetSelected.id">
    <div class="col-12" *ngSwitchCase="0">
      <billet-wks class="row" [cardId]="data.id" [data]="data" [model]="model" [messageQuote]="messageQuote" [symbol]="model?.quote"
        [strategyOptions]="strategiesList" [typeOrderSelected]="typeOrderSelected" [typeOrderOptions]="typeOrderOptions"
        (openConfirmationBillit)="openModalConfirm($event)" [listPosition]='listPosition'
        [hiddenHeaderFull]="hiddenHeaderFull" [auctionHammer]="model?.auctionHammer"
        [financialAccount]="financialAccount" *ngIf="!loading">
      </billet-wks>
    </div>
    <div class="col-12" *ngSwitchCase="1">
      <billet-quick class="row" [cardId]="data.id" [data]="data" [model]="model" [messageQuote]="messageQuote" [symbol]="model?.quote"
        [componentNameAux]="componentName" [isLoggedNegotiation]="isLoggedNegotiation"
        [auctionHammer]="model?.auctionHammer" [statusOmsOnline]="statusOmsOnline"
        (openConfirmationBillit)="openModalConfirm($event)" [listPosition]='listPosition'
        [hiddenHeaderFull]="hiddenHeaderFull" [isSubscribeBook]="isSubscribeBook" *ngIf="!loading">
      </billet-quick>
    </div>
    <div class="col-12" *ngSwitchCase="2">
      <app-book-staircase class="row" [cardId]="data.id" [hasBillet]="true" [data]="data" [model]="model"
        [symbol]="model?.quote" [messageQuote]='messageQuote' [subscribeAggregated]="isSubscribeBook"
        [componentName]="componentName" [hiddenHeaderFull]="hiddenHeaderFull"
        [isLoggedNegotiation]="isLoggedNegotiation" [positionNetDay]="listPosition?.netDay"
        [statusOmsOnline]="statusOmsOnline" [forceConfigCenterElement]="forceConfigCenterElement"
        [auctionHammer]="model?.auctionHammer" (openConfirmationBillit)="openModalConfirm($event)"
        [subscribeScktDailyorder]="subscribeScktDailyorder" [tickSize]="model.priceTickSize"
        [valueInitBookStaircase]="valueInitBookStaircase" [averagePricePos]="averagePricePos" *ngIf="!loading">
      </app-book-staircase>
    </div>
  </div>
</ng-template>

<ng-template #templateConfirmation>
  <span class="btn-confirm">
    <mat-icon matSuffix class="gridster-ignore-drag" svgIcon="close" [matTooltip]="tooltipRemoveFromWks"
      (click)="close()"></mat-icon>
  </span>
  <app-billet-wks-confirmation [model]="model" [indiceFuture]="model.indiceFuture" [lastTrade]="lastTrade"
    (loading)="setLoading($event)" (openConfirmationBillit)="closeModalConfirm($event)">
  </app-billet-wks-confirmation>
</ng-template>
